import { defineStore } from 'pinia'

type PlanType = {
  name: string
  description: string
  slug: string
  is_full: boolean
  is_active: boolean
  shipment_price: string
  has_visible_gift_term: boolean
  has_active_gift_term: boolean
  thank_you_logo: string
  thank_you_logo_alt: string
  thank_you_heading: string
  thank_you_description: string
  thank_you_detail_active: string
  thank_you_detail_full: string
  thank_you_discount: string
}
type MembershipType = {
  name: string
  logo_image: string
  logo_svg: string
  back_logo_image: string
  back_logo_svg: string
  hero_image: string
  subheading: string
  description: string
  blurb: string
  gifting_blurb: string
  bottles_per_delivery: number
  deliveries_per_year: number
  pricing_info: string
  delivery_freq_info: string
  gift_delivery_frequency: string
  slug: string
  plans: PlanType[]
  position: number
  gifting_position: number
  has_visible_gift_term: boolean
  has_active_gift_term: boolean
  store_url: string
  next_shipping_info: string
  partner_club: boolean
  logo_image_optimized: string
  back_logo_image_optimized: string
  hero_image_optimized: string
  page_content: object
  our_pick_stamp: boolean
}
type MembershipData = {
  results: MembershipType[]
}
type QuoteType = {
  id: number
  author_name: string
  quote: string
  subject_code: string
  created_at: string
  updated_at: string
  position: number
}
type QuoteRespponseData = {
  wineaccess: QuoteType[]
  collaborators: QuoteType[]
}

export const useMembershipStore = defineStore('membership', {
  // State
  state: () => ({
    wineClubPreselectedPlan: ref(null),
    membershipTypes: ref([]),
    membershipQuotes: ref({ wineaccess: [], collaborators: [] }),
  }),

  // Actions
  actions: {
    setWineClubPreselectedPlan(value) {
      this.wineClubPreselectedPlan = value
    },
    async fetchMembershipTypes() {
      try {
        const { data, error } = await useFetch<MembershipData>(
          '/api/membership/list/',
        )
        if (error.value) throw error.value

        this.membershipTypes = data.value?.results || []
      } catch (e) {
        console.error('Error fetching membership types:', e)
        throw e
      }
    },
    async fetchMembershipQuotes() {
      try {
        const { data, error } = await useFetch<QuoteRespponseData>(
          '/api/membership/quotes/',
        )
        if (error.value) throw error.value

        this.membershipQuotes = data.value || {
          wineaccess: [],
          collaborators: [],
        }
      } catch (e) {
        console.error('Error fetching membership quotes:', e)
        throw e
      }
    },
  },
})
